(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    

  customElements.whenDefined('details-disclosure').then(() => {

    class FooterMenu extends DetailsDisclosure {

      constructor() {

        super();

        this.reset(false);

        window.addEventListener('on:breakpoint-change', this.reset.bind(this));

      }

      reset() {

        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;

        const isConfirmNewsletter = !isLargeScreen &&

          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {

          this.toggle.setAttribute('tabindex', '-1');

        } else {

          this.toggle.removeAttribute('tabindex');

        }

      }

    }

    if (!customElements.get('footer-menu')) {

      customElements.define('footer-menu', FooterMenu);

    }

  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["grextor-buying-guides"] && !Shopify.designMode) return;
  try {
    
function initializeGrextorGuides(scope) {
  scope.querySelectorAll('.gx-guides').forEach(root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const filters = root.querySelector('.gx-guides__filters');
    const cards = Array.from(root.querySelectorAll('[data-gx-category]'));
    const status = root.querySelector('.gx-guides__status');
    filters.hidden = false;
    filters.addEventListener('click', event => {
      const button = event.target.closest('[data-gx-filter]');
      if (!button) return;
      const category = button.dataset.gxFilter;
      filters.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      let visible = 0;
      cards.forEach(card => {
        card.hidden = category !== 'all' && card.dataset.gxCategory !== category;
        if (!card.hidden) visible++;
      });
      status.textContent = visible + ' ' + (visible === 1 ? root.dataset.singleLabel : root.dataset.pluralLabel);
    });
  });
}
initializeGrextorGuides(document);
document.addEventListener('shopify:section:load', event => initializeGrextorGuides(event.target));

  } catch(e) { console.error(e); }
})();
})();
